import React, { useState } from "react";
import DetailData from "./dataHistory.view";
import AlmondList from "../almondListHistory";
import EntamadoraList from "../entamadoraListHistory";
import LagarList from "../lagarListHistory";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TYPE_ALMOND, TYPE_ENTAMADO, TYPE_LAGAR } from "../../../constants";

const queryClient = new QueryClient();
const queryClient2 = new QueryClient();
const queryClient3 = new QueryClient();

const DataHistoryContainer = () => {
  const [data, setData] = useState([]);
  const [type, setType] = useState(TYPE_ALMOND.code);
  const [yearsSelection, setYearsSelection] = useState(
    new Date().getFullYear()
  );

  const handlerOnChangeType = (type) => {
    setType(type);
  };

  const handleOnYearsSelection = async (value) => {
    setYearsSelection(value?.value || 0);
  };

  return (
    <>
      <DetailData
        onSelectType={handlerOnChangeType}
        onYearsSelection={handleOnYearsSelection}
        typeSelected={type}
        yearsSelection={yearsSelection}
      />
      <div className="data">
        {type === TYPE_ALMOND.code && (
          <QueryClientProvider client={queryClient}>
            <AlmondList
              className="marg-top-1rem"
              filters={{ year: yearsSelection }}
            />
          </QueryClientProvider>
        )}
        {type === TYPE_ENTAMADO.code && (
          <QueryClientProvider client={queryClient2}>
            <EntamadoraList
              className="marg-top-1rem"
              filters={{ year: yearsSelection }}
            />
          </QueryClientProvider>
        )}
        {type === TYPE_LAGAR.code && (
          <QueryClientProvider client={queryClient3}>
            <LagarList
              className="marg-top-1rem"
              filters={{ year: yearsSelection }}
            />
          </QueryClientProvider>
        )}
      </div>
    </>
  );
};

DataHistoryContainer.propTypes = {};

export default DataHistoryContainer;
